import Vue from 'vue';
import Router from 'vue-router';
import { PageNotFound } from './shared/components';
import store from "./app-state";
import clientRoutes from "@/app/client/client-routes";

const baseRoutes = [
  {
    path: '/',
    redirect: '/main',
  },
  {
    path: '/404',
    name: 'Page404',
    component: PageNotFound,
    meta: {
      title: 'Страница не найдена',
      wfPage: '6667fca8692ff013d2a6a92b',
      wfSite: '652921c910bae02d8870dddf'
    },
  },
];

Vue.use(Router);
const router = new Router({
  mode: 'hash',
  routes: [
    ...baseRoutes,
    ...clientRoutes,
    {
      path: '*',
      redirect: '/404',
    },
  ],
  // Добавьте эти функции для правильной работы с query-параметрами
  parseQuery(query) {
    const searchParams = new URLSearchParams(query)
    const params = {}
    for (const [key, value] of searchParams.entries()) {
      params[key] = value
    }
    return params
  },
  stringifyQuery(query) {
    const searchParams = new URLSearchParams()
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        searchParams.append(key, query[key])
      }
    }
    const queryString = searchParams.toString()
    return queryString ? `?${queryString}` : ''
  },
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }; // прокрутка в начало страницы
    }
  },
});

router.beforeEach((to, from, next) => {
  // Автоматически сохраняем query-параметры при переходах
  if (Object.keys(to.query).length === 0 && Object.keys(from.query).length > 0) {
    next({ path: to.path, query: from.query, hash: to.hash })
  } else {
    next()
  }

  document.title = to.meta.title || 'Всем займы'
  if (to.meta.wfPage) {
    document.documentElement.setAttribute('data-wf-page', to.meta.wfPage)
  }
});

export default router;
